/**
 * Wrapper sobre @simplewebauthn/browser pra registro e login WebAuthn.
 *
 * O backend devolve options no formato JSON do PublicKeyCredentialCreationOptions
 * (com base64url nos bytes). simplewebauthn cuida da conversão.
 */
import {
  startRegistration,
  startAuthentication,
  browserSupportsWebAuthn,
  platformAuthenticatorIsAvailable,
} from '@simplewebauthn/browser';
import { api } from '../api/client';
import type { User } from '../api/types';

export { browserSupportsWebAuthn, platformAuthenticatorIsAvailable };

interface LoginResponse {
  token: string;
  user: User;
}

/**
 * Registro de novo dispositivo. Se o usuário já estiver logado, pega via JWT.
 * Se for o primeiro acesso (bootstrap), passa o email do admin.
 */
export async function registerDevice(opts: {
  nickname?: string;
  bootstrapEmail?: string;
}): Promise<LoginResponse> {
  const optionsResp = await api.post(
    '/auth/register/options',
    opts.bootstrapEmail ? { email: opts.bootstrapEmail } : {},
  );
  const credential = await startRegistration({ optionsJSON: optionsResp.data });
  const verifyResp = await api.post('/auth/register/verify', {
    credential,
    nickname: opts.nickname,
    email: opts.bootstrapEmail,
  });
  return verifyResp.data;
}

/** Login via passkey (browser pergunta qual usar, faz biometria). */
export async function loginWithPasskey(): Promise<LoginResponse> {
  const optionsResp = await api.post('/auth/login/options');
  const credential = await startAuthentication({ optionsJSON: optionsResp.data });
  const verifyResp = await api.post('/auth/login/verify', { credential });
  return verifyResp.data;
}
